import {scaleLinear, mean} from "d3";

function kernelDensityEstimator(kernel, X) {
    return function(V) {
        return X.map(function(x) {
            return [x, mean(V, function(v) { return kernel(x - v); })];
        });
    }
}

function kernelEpanechnikov(k) {
    return function(v) {
        return Math.abs(v /= k) <= 1 ? 0.75 * (1 - v * v) / k : 0;
    };
}

// function kernelGaussian(k) {
//     return function(v) {
//         const gaussianConstant = 1 / (Math.sqrt(2 * Math.PI));
//         return Math.abs(v /= k) <= 1 ? gaussianConstant * (Math.exp(-.5 * v * v)) : 0;
//     };
// }

export default function createGaussian(debts) {
    let values = debts.filter((jsonEntry) => {
        if (jsonEntry["medianDebt"] === -1)
            return false;
        return true;
    }).map((jsonEntry) => {
        return jsonEntry["medianDebt"];
    }).sort((a,b) => {
        return a-b;
    })

    let x = scaleLinear().domain([0, 52500]).range([0,800]);
    // Compute kernel density estimation
    let kernel = kernelEpanechnikov(4000);
    let kde = kernelDensityEstimator(kernel, x.ticks(1500));
    let density = kde(values);

    return density.map((dp) => {
        return(
            {
                x: dp[0],
                y: dp[1]
            }
        )
    })

}